import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}],["path",{"d":"M3 7l9 6l9 -6","key":"svg-2"}]]

const IconMailMinus = createReactComponent('outline', 'mail-minus', 'MailMinus', __iconNode);

export default IconMailMinus;